module.exports = __webpack_public_path__ + "static/pic09.c8d54f8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pics/pic09.jpg
// module id = 524
// module chunks = 159055269280251